/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface MarkNotificationAsRead$Params {
  id_notification_intervenant: string;
}

export function markNotificationAsRead(
  http: HttpClient,
  rootUrl: string,
  params: MarkNotificationAsRead$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, markNotificationAsRead.PATH, 'put');
  if (params) {
    rb.path('id_notification_intervenant', params.id_notification_intervenant, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

markNotificationAsRead.PATH = '/v1/centre-notification/{id_notification_intervenant}/read';
